var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropzoneUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6249_129078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.35 5.303C18.436 2.242 15.485 0 11.985 0 9.182 0 6.731 1.44 5.397 3.587 2.367 3.872 0 6.312 0 9.279 0 12.44 2.683 15 5.993 15h12.918C21.72 15 24 12.825 24 10.142c0-2.542-2.046-4.627-4.651-4.84zM16.415 8.39h-1.962a.165.165 0 00-.168.16v3.494c0 .088-.075.16-.168.16h-4.076a.164.164 0 01-.168-.16V8.551a.165.165 0 00-.168-.16H7.744c-.149 0-.224-.171-.12-.273l4.335-4.251a.174.174 0 01.241 0l4.336 4.25c.104.103.029.273-.12.273z",
    fill: "#999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6249_129078"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v15H0z"
  })))));
}
SvgDropzoneUpload.displayName = 'DropzoneUpload';
export default SvgDropzoneUpload;